(function(){
    angular
        .module('app')
        .directive('ngListactividad', listactividad);

        listactividad.$inject = ['ContentService','$timeout','$compile','$sce'];
        function listactividad(ContentService,$timeout,$compile,$sce){
            return {
            //restrict:'A',
            //replace: true,
            templateUrl:'/backend/app/views/listactividad.html',
            transclude: true,
            scope: { config:'=',tipocuadro:'=',cuadroid:"=", nodetype:"=" },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	scope.fields = scope.config.fields;
                	scope.resultados = [];
                	scope.items = "";
                	scope.loading = false;
                	scope.pagina = 0;
                	scope.maxPag = "";
                	scope.inCampos = function(field){
                		var res = false;
                		for(var cont=0;cont<scope.config.campos.length && !res;cont++){
                			if(field["name"]==scope.config.campos[cont]){
                				res = true;
                			}
                		}
                		return res;
                	}
                	scope.initList = function(){
                		scope.loading = true;
			          ContentService.getListado(scope.nodetype,scope.pagina,scope.tipocuadro,scope.cuadroid,function(data){
			            scope.items = data.total;
			            scope.maxPag = data.maxPag;
                		scope.loading = false;
			            scope.resultados = data.result;
			           
			          });
                	}
                	scope.prevPag = function(){
                		scope.pagina--;
                		scope.initList();

                	}
					scope.nextPag = function(){
						scope.pagina++;
						scope.initList();

					}


					scope.initPopup = function(tipocuadro,content_id,lang_id_copy,duplicar,modelSearch=null){
						console.log("E");
						vm = {};
			            vm.tipocuadro=tipocuadro;
			            vm.lang_id_copy = lang_id_copy;
			            vm.duplicar = duplicar;
			            vm.content_id = content_id;
			            ContentService.getCampos(vm,function(data){
			                vm.campos = data.campos;
			                for(var cont=0;cont<data.campos.length;cont++){
			                    vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = data.campos[cont]["value"];
			                    if(modelSearch!=null){
			                        if(typeof(vm.modelSearch["ContentSearch"][data.campos[cont]["name"]]) != 'undefined'){
			                            vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = vm.modelSearch["ContentSearch"][data.campos[cont]["name"]];
			                        }
			                    }
			                }
			                vm.camposHtml = data.html;
			                vm.loading = false;
			                vm.contentCreateModal = "";
			                vm.contentCreateModal = $uibModal.open({
			                      animation: true,
			                      ariaLabelledBy: 'modal-title-top',
			                      ariaDescribedBy: 'modal-body-top',
			                      templateUrl: 'contentpopup.html',
			                      size: 'lg',
			                      controller: function($scope) {
			                        $scope.cc = vm;
			                        $scope.camposHtml = data.html;
			                        $scope.okForm = function(){
			                            vm.saveContenido(function(){
			                                location.reload();
			                            });
			                            console.log(vm.camposActual);
			                            vm.contentCreateModal.close();
			                        }
			                        $scope.koForm = function(){
			                            vm.contentCreateModal.close();
			                        }
			                      }
			                });
			            });
			            
			        }


                	scope.initList();
                });
            }
          }
      }
})();